var cantidades = function () {
    var formularios = Array.from(document.querySelectorAll('.bloque--formulario'));
    formularios.forEach(function (formulario) {
        Array.from(formulario.querySelectorAll('.campo--cantidades')).forEach(function (bloque) {
            var descripcion = bloque.querySelector('.cantidades__descripcion'), input = bloque.querySelector('.cantidades__input'), periodicidades = Array.from(formulario.querySelectorAll('[data-nombre="periodicidad"] input'));
            if (!descripcion || !input) {
                return;
            }
            var radios = Array.from(bloque.querySelectorAll('input[type="radio"]'));
            var actualiza = function (radio, vaciar) {
                if (vaciar === void 0) { vaciar = true; }
                return function () {
                    if (vaciar) {
                        input.value = '';
                    }
                    if (!radio.value) {
                        radio.parentElement.appendChild(input);
                        input.type = 'number';
                        input.required = true;
                        input.focus();
                    }
                    else {
                        input.value = radio.value;
                        input.type = 'hidden';
                    }
                    descripcion.innerHTML = radio.dataset.descripcion || '';
                };
            };
            radios.forEach(function (radio) { return radio.addEventListener('change', actualiza(radio)); });
            // Marcamos el radio por defecto
            radios.filter(function (radio) { return radio.checked; }).forEach(function (radio) { return actualiza(radio, false)(); });
            input.addEventListener('keyup', function (e) {
                if (e.key === 'Escape') {
                    radios[2].checked = true;
                    radios[2].focus();
                    actualiza(radios[2])();
                }
            });
            if (periodicidades.length) {
                var actualizaInput_1 = function (periodicidad) {
                    radios
                        .filter(function (x) { return x.dataset.valueMensual; })
                        .forEach(function (radio) {
                        var actualizar = input.value === radio.value;
                        radio.value = radio.dataset["value" + periodicidad.value[0].toUpperCase() + periodicidad.value.slice(1)] || '';
                        radio.previousElementSibling.innerHTML = radio.value + '&nbsp;€';
                        if (actualizar) {
                            input.value = radio.value;
                        }
                    });
                    radios
                        .filter(function (x) { return x.dataset.minimoMensual; })
                        .forEach(function (radio) {
                        input.min = radio.dataset["minimo" + periodicidad.value[0].toUpperCase() + periodicidad.value.slice(1)] || '';
                    });
                };
                periodicidades.forEach(function (periodicidad) { return periodicidad.addEventListener('change', function (e) {
                    var target = e.target;
                    if (target.checked) {
                        actualizaInput_1(target);
                    }
                }); });
                actualizaInput_1(periodicidades[0]);
            }
        });
    });
};
export default cantidades;
